function Service() {
  return (
    <svg
      width="52"
      height="64"
      viewBox="0 0 52 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 195 1">
        <path
          id="Vector"
          d="M42.6669 2.93359H8.53359C5.4408 2.93359 2.93359 5.4408 2.93359 8.53359V55.4669C2.93359 58.5597 5.4408 61.0669 8.53359 61.0669H42.6669C45.7597 61.0669 48.2669 58.5597 48.2669 55.4669V8.53359C48.2669 5.4408 45.7597 2.93359 42.6669 2.93359Z"
          stroke="#150828"
          strokeWidth="1.25"
        />
        <path
          id="Vector_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5961 13.7035C27.2823 15.291 26.1053 16.4328 24.9674 16.2537C23.8295 16.0746 23.1613 14.6425 23.4752 13.055C23.789 11.4675 24.9659 10.3257 26.1038 10.5048C27.2418 10.6839 27.9099 12.116 27.5961 13.7035ZM32.4578 16.5142C31.7548 17.9778 30.3522 18.7503 29.3248 18.2396C28.2973 17.729 28.0341 16.1285 28.737 14.6649C29.4397 13.2013 30.8426 12.4288 31.87 12.9395C32.8974 13.4502 33.1607 15.0506 32.4578 16.5142ZM31.5027 23.3092C32.4567 23.7834 33.7365 23.1133 34.3613 21.8122C34.986 20.5113 34.7191 19.0722 33.7651 18.598C32.811 18.1238 31.531 18.7941 30.9062 20.095C30.2816 21.396 30.5484 22.8351 31.5027 23.3092ZM22.3278 15.8695C22.1196 17.2925 21.1207 18.3653 20.0969 18.2658C19.073 18.1662 18.4119 16.932 18.6203 15.509C18.8286 14.086 19.8275 13.0132 20.8513 13.1127C21.8752 13.2123 22.5363 14.4465 22.3278 15.8695ZM26.5977 28.9638C28 28.7946 29.1048 27.5095 29.534 24.8633C29.9633 22.2171 29.2763 19.1199 26.5422 18.0153C23.808 16.9106 21.1623 18.6613 19.6329 20.863C18.1035 23.0647 18.0014 24.7601 18.8968 25.8523C19.2498 26.283 20.111 26.2794 21.025 26.2756C21.7681 26.2726 22.5461 26.2694 23.1144 26.4989C23.6836 26.7289 24.2429 27.2729 24.7765 27.7922C25.4323 28.4298 26.0492 29.0299 26.5977 28.9638Z"
          fill="#150828"
        />
        <path
          id="Vector_3"
          d="M39.128 34.7725H12.0703C11.6874 34.7725 11.377 35.0829 11.377 35.4658C11.377 35.8487 11.6874 36.1591 12.0703 36.1591H39.128C39.5109 36.1591 39.8213 35.8487 39.8213 35.4658C39.8213 35.0829 39.5109 34.7725 39.128 34.7725Z"
          fill="#150828"
        />
        <path
          id="Vector_4"
          d="M39.128 40.3213H12.0703C11.6874 40.3213 11.377 40.6317 11.377 41.0146C11.377 41.3975 11.6874 41.708 12.0703 41.708H39.128C39.5109 41.708 39.8213 41.3975 39.8213 41.0146C39.8213 40.6317 39.5109 40.3213 39.128 40.3213Z"
          fill="#150828"
        />
        <path
          id="Vector_5"
          d="M39.128 45.8662H12.0703C11.6874 45.8662 11.377 46.1766 11.377 46.5595C11.377 46.9425 11.6874 47.2529 12.0703 47.2529H39.128C39.5109 47.2529 39.8213 46.9425 39.8213 46.5595C39.8213 46.1766 39.5109 45.8662 39.128 45.8662Z"
          fill="#150828"
        />
        <path
          id="Vector_6"
          d="M39.128 51.4121H12.0703C11.6874 51.4121 11.377 51.7225 11.377 52.1054C11.377 52.4884 11.6874 52.7988 12.0703 52.7988H39.128C39.5109 52.7988 39.8213 52.4884 39.8213 52.1054C39.8213 51.7225 39.5109 51.4121 39.128 51.4121Z"
          fill="#150828"
        />
      </g>
    </svg>
  );
}

export default Service;
